import { memo } from 'react';
import type { NodeProps, Node } from '@xyflow/react';
import { Flex } from '@nula/core-ui';
import { withDefaults } from '../with-defaults';
import { makeDefault } from './defaults';
import type { EmojiData } from './types';
import { EmojiRenderer } from '@/components/emoji-renderer/emoji-renderer';
import { SelectionTransformer } from '@/features/canvas/engine/selection/selection-transformer';
import styles from './component.module.css';

type EmojiNodeShape = Node<EmojiData, 'emoji'>;

export default memo(function EmojiNode({ id, data, selected, dragging, width, height }: NodeProps<EmojiNodeShape>) {
  const d = withDefaults(data, makeDefault);
  const size = Math.min(width ?? 80, height ?? 80);

  const ghost = (
    <Flex align="center" justify="center" className={styles.root}>
      <EmojiRenderer group={d.group} id={d.id} size={size} variant={d.variant} alt="" />
    </Flex>
  );

  return (
    <SelectionTransformer
      nodeId={id}
      nodeType="emoji"
      selected={!!selected}
      dragging={!!dragging}
      ghostContent={ghost}
    >
      <Flex align="center" justify="center" className={styles.root}>
        <EmojiRenderer
          group={d.group}
          id={d.id}
          size={size}
          variant={d.variant}
          alt={`emoji ${d.id}`}
        />
      </Flex>
    </SelectionTransformer>
  );
});
